<template>
  <CLoading :loading="loading" />
  <div class="q-mb-md" style="margin-top: -60px">
    <TestModeSelector v-model="isTestMode" :isHideCopy="true" />
  </div>
  <q-table
    bordered
    flat
    dense
    title="Treats"
    ref="welcomeList"
    v-if="popups"
    :rows="popups"
    row-key="title"
    :rows-per-page-options="[10]"
    separator="cell"
    :no-data-label="$t('messages.no_data_available')"
    class="text-grey-8"
  >
    <template v-slot:header="props">
      <q-tr>
        <q-th rowspan="2" key="action" class="text-center" style="width: 50px"
          ><span class="text-bold">{{ $t('label.prod') }}</span></q-th
        >
        <q-th rowspan="2" key="action" class="text-center" style="width: 50px"
          ><span class="text-bold">{{ $t('label.test') }}</span></q-th
        >
        <q-th rowspan="2" key="action" class="text-center" style="width: 100px"></q-th>
        <q-th rowspan="2" class="text-center" style="width: 64px"></q-th>

        <q-th :props="props" rowspan="2" key="popup_name">
          <span class="text-bold">{{ $t('label.popup.popup_name') }}</span>
        </q-th>
        <q-th :props="props" rowspan="2" key="total_display">
          <span class="text-bold">{{ $t('label.total_display') }}</span>
        </q-th>
        <q-th :props="props" rowspan="2" key="click_rate">
          <span class="text-bold">{{ $t('label.click_rate') }}</span>
        </q-th>
        <q-th :props="props" rowspan="2" key="total_click">
          <span class="text-bold">{{ $t('label.total_click') }}</span>
        </q-th>
        <!-- <q-th :props="props" rowspan="2" key="success_rate">
          <span class="text-bold">CVR</span>
        </q-th>
        <q-th :props="props" rowspan="2" key="success_count">
          <span class="text-bold">CV</span>
        </q-th> -->
        <q-th :props="props" rowspan="2" key="updated_at">
          <span class="text-bold">{{ $t('label.updated_at') }}</span>
        </q-th>
      </q-tr>
    </template>
    <template v-slot:body="props">
      <q-tr :props="props" :index="props.rowKey">
        <q-td>
          <q-toggle
            round
            v-model="props.row.is_active"
            val="props.row.is_active"
            @click="handleToggleActive(props.row)"
          />
        </q-td>
        <q-td>
          <q-toggle
            round
            v-model="props.row.is_test_mode"
            val="props.row.is_test_mode"
            @click="handleToggleTest(props.row)"
          />
        </q-td>
        <q-td key="action" :props="props.index">
          <q-btn size="sm" flat round icon="edit" :to="onEdit(props.row)" class="q-mr-sm" />
          <app-copy-button @click="onCopy(props.row)" class="q-mr-sm" />
          <q-btn size="sm" flat round color="red" icon="delete" @click="onDelete(props.row)" class="q-mr-sm" />
        </q-td>
        <q-td>
          <q-avatar rounded size="64px" v-if="props.row.images">
            <img :src="props.row.images[0].pc.img_thumb" />
          </q-avatar>
        </q-td>
        <q-td key="popup_name" :props="props">
          {{ props.row.popup_name }}<br />
          <a
            :href="getDetailsUrl(props.row)"
            @click="onDetails($event, props.row)"
            class="cursor-pointer hyper-link-chart"
          >
            {{ $t('label.data_transition') }}
          </a>
          <span>/{{ props.row._id.length > 4 ? props.row._id.slice(0, 4) + '***' : props.row._id }}</span>
        </q-td>
        <q-td key="total_display" :props="props">
          {{ numberWithCommas(props.row.total_display) }}
        </q-td>
        <q-td key="click_rate" :props="props"> {{ roundNumber(props.row.click_rate) }}% </q-td>
        <q-td key="total_click" :props="props">
          {{ numberWithCommas(props.row.total_click) }}
        </q-td>
        <!-- <q-td key="success_rate" :props="props">
          {{ props.row.success_rate }}%
        </q-td>
        <q-td key="success_count" :props="props">
          {{ props.row.success_count }}
        </q-td> -->
        <q-td key="updated_at" :props="props">
          {{ props.row.updated_at }}
        </q-td>
      </q-tr>
    </template>

    <template v-slot:top>
      <h2 class="text-h6 text-black">{{ $t('label.popup.popup_list') }}</h2>
      <q-select
        outlined
        dense
        option-value="_id"
        option-label="campaign_name"
        v-model="selectedCampaignId"
        :options="campaigns"
        emit-value
        map-options
        class="q-ma-md"
        style="width: 240px"
        :label="$t('label.popup.campaign')"
      />
      <q-space />
      <DateRangeSelectorV2
        v-model="dateRange"
        :disable="false"
        @update:onChangeDateRange="changeDateRange"
      ></DateRangeSelectorV2>
      <q-btn class="q-ml-md btn-save" no-caps color="primary" @click="onAdd(0)" :label="$t('add_new')" />
    </template>
  </q-table>
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { maska } from 'maska'
import { ICampaign, IDateRangePicker, IPopup } from '@/utils/types'
import { Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import { ACTION_CAMPAIGN, ACTION_POPUP } from '@/store/actions'
import CLoading from '@/components/common/ui/CLoading.vue'
import { constant } from '@/utils/constants'
import { Formater } from '@/utils/formater'
import { DatetimeUtils, lastNMonth, now } from '@/utils/datetime'
import BaseFormMixin from '../common/mixins/BaseFormMixin.vue'
import DateRangeSelectorV2 from '@/components/common/ui/DateRangeSelectorV2.vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'

@Options({
  components: { CLoading, DateRangeSelectorV2, TestModeSelector },
  directives: { maska },
  emits: [],
})
export default class PopupList extends mixins(BaseFormMixin) {
  loading = true
  firstLoad = true
  selectedCampaignId = ''
  isTestMode = false
  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  campaigns: ICampaign[] = []

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get campaignId() {
    return (this.$route.params.campaign_id as string) || ''
  }

  get popups() {
    return cloneDeep(this.$store.getters.popups) || []
  }

  @Watch('campaignId', { immediate: true })
  async loadData() {
    if (!this.selectedAppId) {
      return
    }
    this.firstLoad = true

    this.dateRange = DatetimeUtils.getDateRange('last30Days')

    const cams = await this.$store.dispatch(ACTION_CAMPAIGN.LOAD_COMPACT_ITEMS, {
      app_id: this.selectedAppId,
      is_traffic_source: false,
    })

    this.campaigns = cams

    this.selectedCampaignId = this.campaignId
    await this.loadPopups()
    this.loading = false
    this.firstLoad = false
  }

  @Watch('isTestMode')
  async isTestModeChange() {
    this.loadPopups()
  }

  @Watch('selectedCampaignId')
  handleChangeCampaign() {
    if (this.firstLoad) {
      return
    }
    this.loadPopups()
  }

  changeDateRange(value) {
    if (this.firstLoad) {
      return
    }

    this.dateRange = value
    this.loadPopups()
  }

  async loadPopups() {
    await this.$store.dispatch(ACTION_POPUP.LOAD_ITEMS, {
      app_id: this.selectedAppId,
      is_test_mode: this.isTestMode,
      campaign_id: this.selectedCampaignId,
      date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
      date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
    })
  }

  async updateStatusMode(item: IPopup, statusMode) {
    let mod = ACTION_POPUP.IS_ACTIVE
    if (statusMode) {
      mod = ACTION_POPUP.TEST_MODE
    }
    const isSuccess = await this.$store.dispatch(mod, item)
    if (isSuccess) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    return isSuccess
  }

  async handleToggleActive(record: IPopup) {
    if (!record.is_active) {
      this.updateStatusMode(record, false)
    } else {
      this.$q
        .dialog({
          title: this.$t('messages.confirm'),
          message: this.$t('messages.are_you_sure_to_turn_on_active_for_this_item'),
          cancel: {
            flat: true,
            label: this.$t('messages.no'),
          },
          ok: {
            flat: true,
            label: this.$t('messages.yes'),
          },
          persistent: true,
        })
        .onOk(async () => {
          this.updateStatusMode(record, false)
        })
        .onCancel(async () => {
          record.is_active = false
        })
    }
  }

  async handleToggleTest(record: IPopup) {
    this.updateStatusMode(record, true)
  }

  onAdd() {
    this.goto('popup_setting', {
      app_id: this.selectedAppId,
      campaign_id: this.selectedCampaignId,
      action_type: constant.ACTION_TYPE.ADD,
    })
  }

  onEdit(data: IPopup) {
    return this.detailPath('popup_setting', {
      app_id: data.app_id,
      campaign_id: data.campaign_id,
      popup_id: data._id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  onCopy(data: IPopup) {
    this.goto('popup_setting', {
      app_id: data.app_id,
      campaign_id: data.campaign_id,
      popup_id: data._id,
      action_type: constant.ACTION_TYPE.COPY,
    })
  }

  async onDelete(data: IPopup) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_POPUP.DELETE, data._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
        }
      })
  }

  onDetails(event, data: IPopup) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('popup_details', {
      app_id: this.selectedAppId,
      campaign_id: data.campaign_id,
      popup_id: data._id,
      from_date: lastNMonth(1),
      to_date: now(),
    })
  }

  getDetailsUrl(data) {
    // Construct the URL as a string for direct navigation
    return this.$router.resolve({
      name: 'popup_details',
      params: {
        app_id: this.selectedAppId,
        campaign_id: data.campaign_id,
        popup_id: data._id,
        from_date: lastNMonth(1),
        to_date: now(),
      },
    }).href
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  detailPath(name: string, params = {}) {
    return {
      name: name,
      params: params,
    }
  }

  numberWithCommas(num) {
    return Formater.numberFormat(num)
  }

  roundNumber(num) {
    return Formater.round(num)
  }
}
</script>
<style lang="sass" scoped></style>
